export const downloadBlob = (blob: Blob, filename: string): void => {
  const objectUrl = window.URL.createObjectURL(blob);
  const link = document.createElement('a');

  link.href = objectUrl;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  // Defer revoke to allow the browser to initiate the download
  setTimeout(() => window.URL.revokeObjectURL(objectUrl), 100);
};
